var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanternA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.98 334.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbca00;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #3b0000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: #880404;\n      }\n\n      .cls-5 {\n        fill: #3b0000;\n      }\n\n      .cls-6 {\n        fill: #ffa617;\n      }\n\n      .cls-7 {\n        fill: #fff;\n        mix-blend-mode: soft-light;\n        opacity: .5;\n      }\n\n      .cls-8 {\n        fill: #fbe394;\n        mix-blend-mode: multiply;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.78,
    x2: 72.78,
    y2: 305.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.14,279.7c0,5.17-4.19,9.36-9.36,9.36s-9.36-4.19-9.36-9.36,4.19-9.36,9.36-9.36,9.36,4.19,9.36,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.55,330.25c-3.15-3-5.4-6.99-6.81-11.1-1.51-4.4-1.88-9.12-3.31-13.55l-13.8.29c-.77,9.05-2.77,18-5.91,26.52,3.61.95,7.29,1.49,11.03,1.67.11-.67.21-1.35.32-2.02.05.64.1,1.28.15,1.92,4.38.23,8.93-.1,13.23-.94-.17-1.26-.39-2.54-.56-3.8.65.85,1.3,1.71,1.94,2.56,1.23-.52,2.49-1.03,3.72-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.54,298.67c-4.49,0-8.12,3.64-8.12,8.12h16.25c0-4.49-3.64-8.12-8.12-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.05,254.28h67.46c3.87,0,7.01-3.14,7.01-7.01v-17.28H32.04v17.28c0,3.87,3.14,7.01,7.01,7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.13,47.49H39.43c-3.83,0-6.93,3.1-6.93,6.93v17.09h80.56v-17.09c0-3.83-3.1-6.93-6.93-6.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 81.92 0 81.92 6.07 64.89 134.92 64.89 140.98 81.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 81.92 0 81.92 6.07 98.95 134.92 98.95 140.98 81.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 115.98 0 115.98 6.07 98.95 134.92 98.95 140.98 115.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 115.98 0 115.98 6.07 133.01 134.92 133.01 140.98 115.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 150.04 0 150.04 6.07 133.01 134.92 133.01 140.98 150.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 150.04 0 150.04 6.07 167.07 134.92 167.07 140.98 150.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 184.1 0 184.1 6.07 167.07 134.92 167.07 140.98 184.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 184.1 0 184.1 6.07 201.14 134.92 201.14 140.98 184.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.98 218.17 0 218.17 6.07 201.14 134.92 201.14 140.98 218.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.98 218.17 0 218.17 6.07 235.2 134.92 235.2 140.98 218.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "134.92 98.95 140.98 81.92 134.92 64.89 90.52 64.89 96.58 81.92 90.52 98.95 96.58 115.98 90.52 133.01 96.58 150.04 90.52 167.07 96.58 184.1 90.52 201.14 96.58 218.17 90.52 235.2 134.92 235.2 140.98 218.17 134.92 201.14 140.98 184.1 134.92 167.07 140.98 150.04 134.92 133.01 140.98 115.98 134.92 98.95"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 36.96,
    cy: 119.69,
    rx: 23.54,
    ry: 43.26
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanternA);
export default __webpack_public_path__ + "static/media/lanternA.752bf8eecde4042237f18bd3f6e5ba45.svg";
export { ForwardRef as ReactComponent };